'use client';

import { cn } from '@/lib/tailwind';
import { useConsent, useServiceConsentGranted } from '@/features/consent';
import { ConsentOverlay } from './ConsentOverlay';

/** Matches the catalog entry in consent-catalog.constants.ts. */
const SERVICE_ID = 'youtube';

type Props = {
    src: string;
    title: string;
    placeholderImageUrl?: string;
    placeholderImageAlt?: string;
    consentText: string;
    consentButtonText: string;
    privacyPageSlug?: string;
    className?: string;
};

export function YouTubeEmbedAndConsent({
    src,
    title,
    placeholderImageUrl,
    placeholderImageAlt,
    consentText,
    consentButtonText,
    privacyPageSlug,
    className,
}: Props) {
    const { grantService } = useConsent();
    const accepted = useServiceConsentGranted(SERVICE_ID);

    // The 2-click overlay grants YouTube alone; the banner keeps asking for the rest.
    function acceptConsent() {
        grantService(SERVICE_ID);
    }

    return (
        <div className={cn('relative w-full aspect-video', className)}>
            {accepted ? (
                <iframe
                    src={src}
                    title={title}
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="absolute inset-0 w-full h-full"
                />
            ) : (
                <ConsentOverlay
                    placeholderImageUrl={placeholderImageUrl}
                    placeholderImageAlt={placeholderImageAlt}
                    consentText={consentText}
                    consentButtonText={consentButtonText}
                    privacyPageSlug={privacyPageSlug}
                    onAccept={acceptConsent}
                />
            )}
        </div>
    );
}
